export const formatPhoneNumber = (number) => {
  const str = number.toString();

  const areaCode = str.slice(0, 3);
  const centralOfficeCode = str.slice(3, 6);
  const lineNumber = str.slice(6, 10);

  return `(${areaCode}) ${centralOfficeCode}-${lineNumber}`;
};
